import { render, staticRenderFns } from "./SystemTag.vue?vue&type=template&id=2bbb9542&scoped=true&"
import script from "./SystemTag.vue?vue&type=script&lang=js&"
export * from "./SystemTag.vue?vue&type=script&lang=js&"
import style0 from "./SystemTag.vue?vue&type=style&index=0&id=2bbb9542&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb9542",
  null
  
)

export default component.exports